import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { AutoForm } from "app/components/Form/AutoForm"
import { useRouter } from "app/components/RouterProvider"
import { LoggedOutLayout } from "app/components/LoggedOutLayout"
import type { Components, FormSchema } from "@w3rone/json-schema-form"

export const UserSecurityLoginPage = ({
  csrfToken,
  lastUsername,
  error,
}: UserSecurityLoginPageProps) => {
  const router = useRouter()

  return (
    <LoggedOutLayout>
      {error ? (
        <Typography sx={{ textAlign: "center", color: "error.main" }}>
          {error}
        </Typography>
      ) : null}
      <Box>
        <AutoForm
          schema={schema}
          initialValue={{
            username: lastUsername,
            _remember_me: true,
            _csrf_token: csrfToken,
          }}
          components={{ ActionsWrapper }}
          submitLabel={"Connexion"}
        />
      </Box>
      <Button href={router.generate("app_security_forgotten")}>
        Mot de passe oublié
      </Button>
    </LoggedOutLayout>
  )
}

export interface UserSecurityLoginPageProps {
  csrfToken: string
  lastUsername: string
  error?: string
}

const ActionsWrapper: Components["ActionsWrapper"] = ({ children }) => {
  return (
    <Box sx={{ mt: 4, display: "flex", flexDirection: "column" }}>
      {children}
    </Box>
  )
}

const schema: FormSchema = {
  $id: "",
  $schema: "",
  title: "",
  options: {
    form: { method: "POST", async: false, action: "" },
    layout: "default",
    widget: "login",
  },
  type: "object",
  properties: {
    username: {
      title: "Email",
      type: "string",
      options: {
        widget: "text",
        layout: "default",
      },
    },
    password: {
      title: "Mot de passe",
      type: "string",
      options: {
        widget: "password",
        layout: "default",
      },
    },
    _remember_me: {
      title: "Se souvenir de moi",
      type: "boolean",
      options: {
        widget: "checkbox",
        layout: "default",
      },
    },
    _csrf_token: {
      title: "",
      type: "string",
      options: {
        widget: "hidden",
        layout: "default",
      },
    },
  },
  required: [],
}
